import { api } from "@/api";
import { QueryProps } from "@/types/Api";
import { UserProfileReport } from "@/types/ApiResponses/UserProfile";

export interface UserProfileReportParams {
  userId: number;
  // ISO bounds; both absent = since the account was opened.
  startDate?: string;
  endDate?: string;
  // false = leave out coupons moved to the trash.
  includeTrash?: boolean;
}

export const getUserProfileReport = async (
  props: QueryProps<UserProfileReportParams>
): Promise<UserProfileReport> => {
  const { userId, ...params } = props.params;
  const res = await api.client.get(`/user-profiles/${userId}/report`, {
    signal: props.signal,
    params,
  });
  return res.data;
};
